<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style=" border-radius: 5px !important;padding-left:0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousEx" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Cargo Tracking</b-navbar-brand>
        </b-navbar>
        <banner-component :allModuleIdBanner="this.airFreightModel.allModuleId ? this.airFreightModel.allModuleId : ''"
          :jobSeriesBanner="this.airFreightModel.airFFExportSeries ? this.airFreightModel.airFFExportSeries : ''"
          :bannerClientName="this.getCLientData[0].clientName ? this.getCLientData[0].clientName : '' "
          iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <md-layout gutter>


              <md-layout md-flex="45">
                <md-layout md-flex="100">
                  <label>Assignment No.</label>

                  <b-form-input :formatter="capitalizeAll" name="assignmentNumber" id="assignmentNumber"
                    v-model="BookingShippingLine.assignmentNumber" disabled></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout gutter class="labelMargtop">


              <md-layout md-flex="45">
                <md-layout md-flex="100">
                  <label>MAWBL No.</label>

                  <b-form-input :formatter="capitalizeAll" name="MAWBNumber" id="MAWBNumber"
                    v-model="BookingShippingLine.MAWBNumber" disabled></b-form-input>
                </md-layout>

                <span class="error"
                  v-if="!BookingShippingLine.MAWBNumber">{{errorBookingShippingLine.MAWBNumber}}</span>
              </md-layout>
            </md-layout>
            <div v-if="tentativeDetailArrayList.length<=0">
              <md-layout md-gutter class="labelMargtop">


                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Flight Number</label>

                    <b-form-input :formatter="capitalizeAll" name="flightNumber" id="flightNumber"
                      v-model="BookingShippingLine.flightNumber"></b-form-input>
                  </md-layout>

                  <span class="error"
                    v-if="!BookingShippingLine.flightNumber">{{errorBookingShippingLine.flightNumber}}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="30">
                  <label for="containerTypeId">From AirPort</label>

                  <model-list-select isDisabled option-value="pickupId" option-text="pickupLocation" :list="portList"
                    placeholder="Select Port Name" v-model="BookingShippingLine.fromAirport"></model-list-select>

                  <span class="error"
                    v-if="!BookingShippingLine.fromAirport">{{errorBookingShippingLine.fromAirport}}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="25">
                  <label for="containerTypeId">To AirPort</label>

                  <model-list-select isDisabled option-value="pickupId" option-text="pickupLocation" :list="portList"
                    placeholder="Select Port Name" v-model="BookingShippingLine.toAirport"></model-list-select>

                  <span class="error"
                    v-if="!BookingShippingLine.toAirport">{{errorBookingShippingLine.toAirport}}</span>
                </md-layout>
              </md-layout>

              <md-layout gutter class="labelMargtop">
                <md-layout md-flex="35"></md-layout>

                <md-layout md-flex="25">
                  <label>Expected Departure Date</label>

                  <date-picker :format="selectDateFormat" lang="en" id="dateDeparture" name="dateDeparture"
                    v-model="BookingShippingLine.dateDeparture"></date-picker>

                  <span class="error"
                    v-if="!BookingShippingLine.dateDeparture">{{errorBookingShippingLine.dateDeparture}}</span>
                </md-layout>

                <md-layout md-flex="10"></md-layout>

                <md-layout md-flex="25">
                  <label>Expected Arrival Date</label>

                  <date-picker :format="selectDateFormat" lang="en" id="dateArrival" name="dateArrival"
                    v-model="BookingShippingLine.dateArrival"></date-picker>

                  <span class="error"
                    v-if="!BookingShippingLine.dateArrival">{{errorBookingShippingLine.dateArrival}}</span>
                </md-layout>
              </md-layout>

              <md-layout gutter class="labelMargtop">
                <md-layout md-flex="35"></md-layout>

                <md-layout md-flex="25">
                  <label>Actual Departure Date</label>

                  <date-picker :format="selectDateFormat" lang="en" id="actualDateDeparture" name="actualDateDeparture"
                    v-model="BookingShippingLine.actualDateDeparture"></date-picker>
                </md-layout>

                <md-layout md-flex="10"></md-layout>

                <md-layout md-flex="25">
                  <label>Actual Arrival Date</label>

                  <date-picker :format="selectDateFormat" lang="en" id="actualDateArrival" name="actualDateArrival"
                    v-model="BookingShippingLine.actualDateArrival"></date-picker>
                </md-layout>
              </md-layout>
            </div>
            <div v-if="tentativeDetailArrayList.length>0">
              <div v-if="showAddAirport==true">
                <b-card style="background:whiteSmoke" class="gutr">
                  <md-layout md-gutter class="labelMargtop">


                    <md-layout md-flex="20">
                      <md-layout md-flex="100">
                        <label>Flight Number</label>

                        <b-form-input :formatter="capitalizeAll" disabled name="flightNumber" id="flightNumber"
                          v-model="moreAirportModel.flightNumber"></b-form-input>
                      </md-layout>

                      <!-- <span
                  class="error"
                  v-if="!BookingShippingLine.flightNumber"
                    >{{errorBookingShippingLine.flightNumber}}</span>-->
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="35">
                      <label for="containerTypeId">From AirPort</label>

                      <model-list-select isDisabled option-value="pickupId" option-text="pickupLocation"
                        :list="locationMultiTrans" placeholder="Select Port Name"
                        v-model="moreAirportModel.fromAirport"></model-list-select>

                      <!-- <span
                  class="error"
                  v-if="!BookingShippingLine.fromAirport"
                    >{{errorBookingShippingLine.fromAirport}}</span>-->
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="35">
                      <label for="containerTypeId">To AirPort</label>

                      <model-list-select isDisabled option-value="pickupId" option-text="pickupLocation"
                        :list="locationMultiTrans" placeholder="Select Port Name"
                        v-model="moreAirportModel.toAirport"></model-list-select>

                      <!-- <span
                  class="error"
                  v-if="!BookingShippingLine.toAirport"
                    >{{errorBookingShippingLine.toAirport}}</span>-->
                    </md-layout>
                  </md-layout>

                  <md-layout gutter class="labelMargtop">


                    <md-layout md-flex="20">
                      <label>Expected Departure Date</label>

                      <date-picker :format="selectDateFormat" disabled lang="en" id="dateDeparture" name="dateDeparture"
                        v-model="moreAirportModel.dateDeparture"></date-picker>

                      <!-- <span
                  class="error"
                  v-if="!BookingShippingLine.dateDeparture"
                    >{{errorBookingShippingLine.dateDeparture}}</span>-->
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="20">
                      <label>Expected Arrival Date</label>

                      <date-picker :format="selectDateFormat" disabled lang="en" id="dateArrival" name="dateArrival"
                        v-model="moreAirportModel.dateArrival"></date-picker>
                      <!-- 
                <span
                  class="error"
                  v-if="!BookingShippingLine.dateArrival"
                    >{{errorBookingShippingLine.dateArrival}}</span>-->
                    </md-layout>
                  </md-layout>

                  <md-layout gutter class="labelMargtop">


                    <md-layout md-flex="20">
                      <label>Actual Departure Date</label>

                      <date-picker :format="selectDateFormat" lang="en" id="actualDateDeparture"
                        name="actualDateDeparture" v-model="moreAirportModel.actualDateDeparture"></date-picker>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="20">
                      <label>Actual Arrival Date</label>

                      <date-picker :format="selectDateFormat" lang="en" id="actualDateArrival" name="actualDateArrival"
                        v-model="moreAirportModel.actualDateArrival"></date-picker>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">


                    <md-layout md-flex="15">
                      <b-button class="mt-3" size="sm" variant="info" @click="addAirport"
                        id="addButtonLoader11">Update</b-button>

                      <md-spinner md-indeterminate id="loader11" style="display:none"></md-spinner>
                    </md-layout>
                  </md-layout>
                </b-card>
              </div>
            </div>

            <div class="mt-3" v-if="tentativeDetailArrayList.length>0">

              <h5>
                <b-badge> Transhipment Details</b-badge>
              </h5>



              <!-- /.box-header -->
              <div class="box-body">
                <table id="ffBookingTentative" class="table table-bordered ">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Flight No.</th>
                      <th>From Airport</th>
                      <th>To Airport</th>
                      <th>Arrival & Departure Details</th>

                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in tentativeDetailArrayList" :key="index">
                      <td>{{index+1}}</td>
                      <td>{{item.flightNumber }}</td>
                      <td>{{item.fromAirportName }}</td>
                      <td>{{item.toAirportName }}</td>
                      <td>
                        <b>Expected Departure Date:</b>
                        {{item.dateDeparture }}
                        <br>
                        <b>Actual Departure Date:</b>
                        {{ item.actualDateDeparture==null?'Peding':item.actualDateDeparture }}
                        <br>
                        <br>
                        <b>Expected Arrival Date :</b>
                        {{item.dateArrival }}
                        <br>
                        <b>Actual Arrival Date :</b>
                        {{item.actualDateArrival==null?'Pending':item.actualDateArrival}}
                      </td>
                      <td>
                        <b-button size="sm" variant="outline-dark" @click="viewEdit(item,index)">
                          Edit
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>

            <!-- <hr class="hr-border" v-if="airFreightModel.airFFType=='fclNormal'"> -->
            <!-- <md-layout gutter v-if="airFreightModel.airFFType=='fclNormal'" class="labelMargtop">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="25">
            <md-layout md-flex="100">
              <label>Client Name</label>

              <b-form-input :formatter="capitalizeAll"
                name="clientName"
                id="clientName"
                v-model="BookingShippingLine.clientName"
                disabled
              ></b-form-input>
            </md-layout>
          </md-layout>

          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <label>Final Cargo Delivery Date</label>

            <date-picker
              lang="en"
              id="finalCargoDeliveryDate"
              name="finalCargoDeliveryDate"
              v-model="BookingShippingLine.finalCargoDeliveryDate"
            ></date-picker>
          </md-layout>
        </md-layout>

        <md-layout gutter v-for="(item,index) in HAWBArray" :key="index" class="labelMargtop">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label for="clientId">Client Name</label>

              <b-form-input :formatter="capitalizeAll" :value="item.clientName" disabled></b-form-input>
            </md-layout>
          </md-layout>

          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="15">
            <md-layout md-flex="100">
              <label>HAWB No.</label>

              <b-form-input :formatter="capitalizeAll" :value="item.HAWBNumber" disabled></b-form-input>
            </md-layout>
          </md-layout>

          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="10">
            <md-layout md-flex="100">
              <label>Delivery Mode</label>

              <b-form-input :formatter="capitalizeAll"
                :value="item.deliveryMode=='upto_AirPort'?'Upto AirPort':item.deliveryMode"
                disabled
              ></b-form-input>
            </md-layout>
          </md-layout>

          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <label>Final CargoDelivery Date</label>

            <date-picker
              lang="en"
              id="HAWBDate"
              name="HAWBDate"
              v-model="finalCargoDeliveryDate[index]"
            ></date-picker>
          </md-layout>
            </md-layout>-->
            <md-layout md-gutter class="gutr">


              <md-layout md-flex="30">
                <b-button v-if="showAddAirport==false" variant="primary" class="mt-3" @click="addTracking"
                  id="addButtonLoader1">Save & Submit</b-button>
                <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPopAddTracking"
      @close="onCloseAddTracking"></md-dialog-confirm>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";

import { ModelListSelect } from "vue-search-select";

import Loading from "vue-loading-overlay";

import "vue-loading-overlay/dist/vue-loading.css";

import moment from "moment";

import BannerComponent from "../allModuleForm/bannerComponent.vue";

import axios from "axios";

import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";

import { globalPermissionStatus } from "../../helper/collection";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Air Freight")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/airFreight/airTrackingFFExport"
      );
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },

  beforeDestroy() {
    // this.$sessionsStorage.set("editExportFCLId", "");
    // this.$sessionsStorage.set("editFFBookingId", "");
  },

  data() {
    return {
      selectDateFormat,
      isLoading: false,

      bookingShipmentName: [
        {
          bookingShipmentVal: "yes",

          bookingShipmentText: "Yes"
        },

        {
          bookingShipmentVal: "no",

          bookingShipmentText: "No"
        }
      ],

      finalCargoDeliveryDate: [],

      value12: "",

      getCLientData: ["gfdg"],

      hawbModal: {
        airBookingId: "",

        moreHawbId: "",

        shipperFreightId: "",

        clientName: "",

        HAWBNumber: "",

        HAWBDate: ""
      },

      errorHawbModal: {
        shipperFreightId: "",

        HAWBNumber: "",

        HAWBDate: ""
      },

      arrayErrorHawbModal: {
        shipperFreightId: "Select Shipper Name",

        HAWBNumber: "Enter HAWB Number",

        HAWBDate: "Enter HAWB Date"
      },

      BookingShippingLine: {
        airTrackingId: "",
        airBookingId: this.$sessionsStorage.get("editAirBookingId"),

        airFcExportId: this.$sessionsStorage.get("editffAirExport"),

        airExecutionId: this.$sessionsStorage.get("editAirExecutionId"),

        airLine: "",

        assignmentNumber: "",

        clientName: "",

        IATAAgent: "",

        bookingDate: "",

        MAWBNumber: "",

        MAWBDate: "",

        HAWBNumber: "",

        HAWBDate: "",

        fromAirport: "",

        toAirport: "",

        flightNumber: "",

        dateDeparture: "",

        dateArrival: "",

        actualDateDeparture: "",

        actualDateArrival: "",

        bookingShipment: "",

        finalCargoDeliveryDate: "",

        destinationDelivery: ""
      },

      errorArrayBookingShippingLine: {
        airLine: "Select Airine Name",

        IATAAgent: "Select Agent",

        bookingDate: "Select Booking Date",

        MAWBNumber: "Enter MAWB Number",

        MAWBDate: "Select MAWB Date",

        fromAirport: "Select From Airport",

        toAirport: "Select To Airport",

        flightNumber: "Enter Flight Number",

        dateDeparture: "Select Departure Date",

        dateArrival: "Select Arrival Date",

        bookingShipment: "Select Booking Shipment"
      },

      errorBookingShippingLine: {
        airFreightBookingId: "",

        airLine: "",

        assignmentNumber: "",

        IATAAgent: "",

        bookingDate: "",

        MAWBNumber: "",

        MAWBDate: "",

        fromAirport: "",

        toAirport: "",

        flightNumber: "",

        dateDeparture: "",

        dateArrival: "",

        bookingShipment: ""
      },

      //  tentativePortNameFull: {},

      portMasterList: [],
      locationMultiTrans: [],

      alert: {
        content: "Added Succesfully",

        ok: "ok"
      },

      airFreightModel: {},

      moreAirportModel: {
        actualDateArrival: "",
        actualDateDeparture: "",
        moreAirportId: "",

        fromAirport: "",

        toAirport: "",

        flightNumber: "",

        dateDeparture: "",

        dateArrival: ""
      },

      errorMoreAirport: {
        fromAirport: "",

        toAirport: "",

        flightNumber: "",

        dateDeparture: "",

        dateArrival: ""
      },

      arratErrorAirport: {
        fromAirport: "Select From Airport",

        toAirport: "Select To Airport",

        flightNumber: "Enter Flight Number",

        dateDeparture: "Select Departure Date",

        dateArrival: "Select Arrival Date"
      },

      tentativeDetailArray: [],

      HAWBArray: [],

      agentMasterList: [],

      deleteId: "",

      validateTrans: true,

      arrayError: [
        "Enter your tentative port Name",

        "Select ETA Date",

        // "Select ETA time",

        "Select ETA Date"

        // "Select ETD time"
      ],

      showAddAirport: false,

      errorBooking: {
        bookingNumber: "",

        validityBookingDate: "",

        SICutOff: "",

        bookingShipment: ""
      },

      bookingLengthError: "",

      arrayBookingError: [
        "Enter Booking Number",

        "Enter Validity Booking Number",

        "Enter SI Cut off",

        "Select Booking Shipment"
      ],

      editIndex: ""
    };
  },

  mounted() {},

  watch: {
    hawbModal: {
      handler: function(newVal, oldVal) {
        console.log("Here Change obj", newVal, oldVal);

        if (this.hawbModal.shipperFreightId != "") {
          let arrayClentId = this.getCLientData.filter(x => {
            return x.shipperFreightId == this.hawbModal.shipperFreightId;
          });

          if (arrayClentId.length > 0) {
            this.hawbModal.clientName = arrayClentId[0].clientName;
          }
        }
      },

      deep: true
    }
  },

  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  destroyed() {},

  components: {
    DatePicker,

    ModelListSelect,

    Loading,
    CustomLoader,

    BannerComponent,
  },

  computed: {
    clientList() {
      return this.getCLientData;
    },

    uploadBookingStatus() {
      return this.BookingShippingLine.uploadBooking != ""
        ? this.BookingShippingLine.uploadBooking.split(",")
        : [];
    },

    tentativeDetailArrayList() {
      return this.tentativeDetailArray;
    },

    portList() {
      return this.portMasterList;
    },

    bookingShipmentList() {
      return this.bookingShipmentName;
    }
  },

  methods: {
    viewEdit(item, index) {
      let mainAry = [];
      mainAry.push(item);
      console.log(mainAry);
      this.showAddAirport = true;
      this.moreAirportModel.moreAirportId = mainAry[0].moreAirportId;
      this.moreAirportModel.flightNumber = mainAry[0].flightNumber;
      this.moreAirportModel.fromAirport = mainAry[0].fromAirport;
      this.moreAirportModel.toAirport = mainAry[0].toAirport;
      this.moreAirportModel.dateDeparture = mainAry[0].dateDeparture;
      this.moreAirportModel.dateArrival = mainAry[0].dateArrival;
      this.moreAirportModel.airBookingId = mainAry[0].airBookingId;
      this.moreAirportModel.actualDateDeparture =
        mainAry[0].actualDateDeparture;
      this.moreAirportModel.actualDateArrival = mainAry[0].actualDateArrival;

      // Object.keys(item).map(x => {
      //   this.moreAirportModel[x] = item[x];
      // });
    },
    addAirport() {
      if (this.validateTrans != false) {
        let newData = {
          moreAirportModel: this.moreAirportModel,
          BookingShippingLine: this.BookingShippingLine,
          onlyExecMain: ""
        };
        console.log(newData);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirExport/addBookingDetail.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              Object.keys(this.moreAirportModel).map(x => {
                this.moreAirportModel[x] = "";
              });

              this.showAddAirport = false;
              this.getData();
            }
          })
          .catch(error => {});
      }
    },
    doLoading() {
      this.isLoading = true;
    },

    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onCloseAddTracking() {},

    previousEx() {
      this.$router.push({
        path: "/airFreight/airFreightExecution"
      });
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;

      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");

      //   let minuteNew = [Hour, minute].join(":");

      return dateNew;
    },

    addTracking() {
      this.BookingShippingLine["finalCargoDeliveryDate"] = "";

      if (this.airFreightModel.airFFType == "fclConsolidation") {
        this.finalCargoDeliveryDate.map(x => {
          this.BookingShippingLine["finalCargoDeliveryDate"] +=
            this.formatDate(x) + ",";
        });
      } else {
        this.BookingShippingLine["finalCargoDeliveryDate"] = this.formatDate(
          this.BookingShippingLine.finalCargoDeliveryDate
        );
      }

      this.BookingShippingLine["airBookingId"] = this.$sessionsStorage.get(
        "editAirBookingId"
      );

      this.BookingShippingLine["airFcExportId"] = this.$sessionsStorage.get(
        "editffAirExport"
      );

      this.BookingShippingLine["airExecutionId"] = this.$sessionsStorage.get(
        "editAirExecutionId"
      );

      // this.validateBooking();

      if (this.validateTrans != false) {
        $("#addButtonLoader1").css("display", "none");

        $("#loader1").css("display", "block");

        let options = {
          method: "POST",

          url: `${URL_BASE}/Api_AirExport/addAirTracking.php`,

          data: JSON.stringify(this.BookingShippingLine),

          crossDomain: true,

          headers: {
            Accept: "application/json",

            "Content-Type": "application/json",

            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const {
              statusText,

              status,

              data
            } = result;

            if ( status == 200 && data) {
              //   this.BookingShippingLine.airBookingId = data.airBookingId;

              //   this.$sessionsStorage.set("editAirBookingId", data.airBookingId);

              $("#loader1").css("display", "none");

              $("#addButtonLoader1").css("display", "block");

              if (this.BookingShippingLine.airTrackingId == "") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }

              this.$refs["addPopAddTracking"].open();

              this.getData();
            }
          })

          .catch(error => {});
      }
    },

    getData() {
      this.doLoading();

      if (this.tentativeDetailArray.length == 1) {
        this.tentativeDetailArray = [];
      }

      let new_data = {
        airFcExportId: this.$sessionsStorage.get("editffAirExport"),

        airExecutionId: this.$sessionsStorage.get("editAirExecutionId"),

        airBookingId:
          this.$sessionsStorage.get("editAirBookingId") != "" &&
          this.$sessionsStorage.get("editAirBookingId") != undefined
            ? this.$sessionsStorage.get("editAirBookingId")
            : ""
      };

      let options = {
        method: "POST",

        url: `${URL_BASE}/Api_AirExport/viewTracking.php`,

        data: JSON.stringify(new_data),

        crossDomain: true,

        headers: {
          Accept: "application/json",

          "Content-Type": "application/json",

          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const {
            statusText,

            status,

            data
          } = result;

          console.log(data);

          if ( status == 200 && data) {
            if (data.portLocationArray.length > 0) {
              this.portMasterList = data.portLocationArray;
            }
            if (data.portLocationArrayMulti.length > 0) {
              this.locationMultiTrans = data.portLocationArrayMulti;
            }
            if (data.allAgent.length > 0) {
              this.agentMasterList = data.allAgent;
            }

            if (data.trackingdata.length > 0) {
              if (data.editFFEX[0].airFFType == "fclConsolidation") {
                Object.keys(this.BookingShippingLine).map(x => {
                  if (x == "finalCargoDeliveryDate") {
                    this.finalCargoDeliveryDate = data.trackingdata[0][x].split(
                      ","
                    );

                    this.BookingShippingLine[x] = data.trackingdata[0][x];
                  } else {
                    this.BookingShippingLine[x] = data.trackingdata[0][x];
                  }
                });
              } else {
                Object.keys(this.BookingShippingLine).map(x => {
                  this.BookingShippingLine[x] = data.trackingdata[0][x];
                });
              }
            } else if (data.ffBookingDetail.length > 0) {
              Object.keys(this.BookingShippingLine).map(x => {
                this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
              });
            }

            Object.keys(data.editFFEX[0]).map(x => {
              this.airFreightModel[x] = data.editFFEX[0][x];
            });
            this.BookingShippingLine.assignmentNumber =
              data.editFFEX[0].airFFExportSeries;

            if (data.editFFEX[0].airFFType == "fclNormal") {
              this.BookingShippingLine.clientName =
                data.clientData[0].clientName;
            }

            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
            }

            if (data.clientData.length > 0) {
              this.getCLientData = data.clientData;
            } else {
              this.getCLientData = [];
            }

            if (data.hawbData.length > 0) {
              this.HAWBArray = data.hawbData;
            } else {
              this.HAWBArray = [];
            }

            this.doLoadingClose();

            this.JqueryFun();
          }
        })

        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// airTrackingFFExport.vue?2f776983